import React from 'react';
import { DEFAULT_COACH_NAME } from './copy';

const SIZES = {
  sm: {
    box: 'w-7 h-7 text-[16px]',
    dot: '-right-px -bottom-px w-2 h-2 shadow-[0_0_0_2px_hsl(var(--background)),0_0_8px_hsl(var(--succeedo-orange)/0.6)]',
  },
  // The opening greeting (D01).
  lg: {
    box: 'w-14 h-14 text-[30px]',
    dot: 'right-px bottom-px w-[11px] h-[11px] shadow-[0_0_0_3px_hsl(var(--background)),0_0_10px_hsl(var(--succeedo-orange)/0.7)]',
  },
};

// The coach's monogram with the orange "online" dot (George designs).
export default function CoachAvatar({ name = DEFAULT_COACH_NAME, size = 'sm' }) {
  const s = SIZES[size] || SIZES.sm;
  return (
    <div
      aria-hidden="true"
      className={`relative shrink-0 rounded-full bg-muted border border-border flex items-center justify-center font-display font-light leading-none text-succeedo-orange ${s.box}`}
    >
      {(name || 'G').charAt(0)}
      <span className={`absolute rounded-full bg-succeedo-orange ${s.dot}`} />
    </div>
  );
}
